const English = {
    AboutUs: "About Us",
    AboutUsTitle: "Arian Exchange | About Us",
    AddNews: "Add New News",
    AddFile: "Add File: ",
    Address: "No. 234, Iran Sokna Building, Northen Shiraz Street, Tehran, Iran",
    Admin: "Admin",
    AdminA: "Appointment",
    AdminN: "Edit News",
    AdminTitle: "Arian Exchange | Website Managment",
    AdminU: "User Info",
    AdsArianCoins: "Have various types of central bank coins with color separation",
    AdsArianCustomer: "Customer orientation is the key to our success and your trust",
    AdsArianServices: "We are at your service with the experienced staffs",
    AdsArianSlang: "Your trust in us is the reason for your constant companionship",
    AdsCenteralBank: "We have an official permission from the Central Bank of Iran",
    AED: " Emirates Dirham",
    AEDTOM: "AED",
    Amount:"Amount",
    Appointment: "Appointment",
    AppointmentBtn: "Appointment",
    Archive: "Archive",
    ArianCurrencyRate: "Arian Currency Rate",
    ArianDesc: "Naser Afshar and Partners Exchange Company was established in 2009 with the aim of providing appropriate foreign exchange services, remittances and buying and selling all kinds of gold coins with an official license from the Central Bank of Iran. Reasonable price, fast delivery of currency to all over the world and customers' confidence in buying and selling are the main goals of Arian Financial Group",
    ArianExchange: "Arian Exchange",
    ArianGoldRate: "Arian Gold Rate",
    Ask: "Ask",
    AskToDel: "Do you want to delete this news: ",
    AUD: "Australian Dollar",
    AUDTOM: "AUD",
    AZADITOM: "AZADI",
    BCHUSD: "BCH / USD",
    Bid: "Bid",
    BTCUSD: "BTC / USD",
    CAD: "Canada Dollar",
    CADTOM: "CAD",
    Clear: "Clear",
    Cancel: "Cancel",
    ChangeFile: "Change File: ",
    Changes: "Changes",
    ChoosePass: "Choose Password",
    Confirmation: "Confirm Password",
    ConfirmToDel: "Confirm Delete",
    ConfirmToEdit: "Confirm Edit",
    ContactUs: "Contact Us",
    Content: "News Content in Persian",
    ContentEn: "News Content in English",
    ConvertorCaption: "<cta>{remain}</cta>",
    ConvertorResult: "<cta>{amount}</cta><b>=</b><p>{result}</p>",
    CopyRight: "© Arian Exchange Company",
    Currency: "Currency",
    CurrencyConvertor: "Arian Rate Convertor",
    CryptoUnit: "The unit rates of each Crypto is Dollar",
    DefaultSelect: "Select the News Type...",
    Delete: "Delete",
    Edit: "Edit",
    Email: "Email",
    EMA: "Golden - EMAMI",
    EMAMITOM: "EMAMI",
    EREL: "Enter only english letters, numbers and sign such as - ! ? % $ . : () \" ' and ,",
    EREM: "Required / Email is not correct",
    EREX: "This email already exists",
    ERFE: "Did not choose file!",
    ERFF: "All the files with jpg, gif, png, svg, tiff, mp4 extensions allowed",
    ERFL: "Enter Only Farsi letters, numbers and sign such as ! ? . : () \" and ,",
    ERFN: "Required / Only letters in English or Farsi are Allowed",
    ERGE: "All the fields except news content are required",
    ERGR: "All the fields are required",
    ERNA: "Your access is not approved",
    ERNR: "Your membership is not approved, please register",
    ERPA: "Required / At least 1 upper letter, 1 lower letter, 1 number, and between 8 to 16 characters",
    ERPC: "Required / Confirmation password does not match",
    ERPH: "Required / Mobile should be 10 to 13 digits",
    ERWR: "Somethings wrong, try again later",
    ERWEP: "Wrong email / password",
    ETHUSD: "ETH / USD",
    EUR: " Euro",
    EURTOM: "EUR",
    Fax: "(+98 21) 880 57967",
    FirstName: "First Name",
    ForeignUnit: "The exchange rates is for each US Dollar",
    GBP: "Pound Sterling",
    GBPTOM: "GBP",
    GRAMTOM: "GRAM",
    Home: "Home",
    HomeTitle: "Arian Exchange | Currency, Gold and Wire Transfer",
    HALFTOM: "HALF",
    LastName: "Last Name",
    LastNews: "Last News",
    LastPrice: "Rate",
    Live: "Live",
    LiveCryptoRate: "Live Crypto Rate",
    LiveForeignRate: "Live Foreign Rate",
    LiveGoldRate: "Live Gold Rate",
    Loading: "loading...",
    Login: "Login",
    LoginTitle: "Arian Exchange | Login",
    Logout: "Logout",
    LTCUSD: "LTC / USD",
    Mobile: "Mobile",
    MoreInfo: "More Info ...",
    NewAccount: "Create New Account",
    News: "News",
    NewsArchive: "News Archive",
    Newsarticle: "Article",
    NewsBtn: "Edit News",
    Newsposter: "Poster",
    NewsTitle: "Arian Exchange | News",
    Newsvideo: "Video",
    NIM: "Golden - HALF",
    NotFoundTitle: "Sorry, the page you are looking for is not available",
    OUNCEUSD: "OUNCE / USD",
    OunceUnit: "The unit rate of each Ounce is Dollar",
    OurTeam: "Our Team",
    OurTeamDesc: "We are proud that during these years we have been accompanied and cooperated only by capable and compassionate staff. We appreciate and know that the absence of each one made it more difficult to be in the current position of this company. We are sure that each of our colleagues has tried to provide the best services in the framework of rules and regulations. We always hope to benefit from a young team, talented and specialized in providing new and efficient services for our loyal customers.",
    Pass: "Password",
    Phone: "(+98 21) 880 59201",
    Product: "Product",
    Quarterly: "Quarterly",
    QUARTERTOM: "QUARTER",
    ROB: "Golden - QUARTER",
    Save: "Save",
    SignIn: "Sign In", 
    SignupTitle: " Arian Exchange | Signup",
    Submit: "Sign Up",
    SuccessReg: "You have successfully registered",
    SUMG: "Process has been successfully completed",
    TableContent: "Content",
    TableOperations: "Operations",
    TableTitle: "Title",
    TableUpdate: "Last Update",
    Title: "News Title in Persian",
    TitleEn: "News Title in English",
    TMA: "Golden - AZADI",
    TOMAN: "Toman",
    TomanUnit: "The unit rates is Toman",
    TRY: "Turkish Lira",
    TRYTOM: "TRY",
    UpdateNews: "Update News",
    USD: "US Dollar",
    USDAUD: "USD / AUD",
    USDCAD: "USD / CAD",
    USDCNY: "USD / CNY",
    USDEUR: "USD / EUR",
    USDGBP: "USD / GBP",
    USDIQD: "USD / IQD",
    USDMYR: "USD / MYR",
    USDTHB: "USD / THB",
    USDTOM: "USD",
    USDTRY: "USD / TRY",
    UNDERTOM: "NOT 1386",
    UserInfoBtn: "User Info",
    Warning: "Your browser does not support the video tag",
    WorkTime: "Sat - Wed <span>9:30 to 16:00</span>",
    WorkTimeEx: "Thur <span>9:30 to 13:30</span>",
    XAUUSD: "Gold Ounce / USD",
    XAGUSD: "Silver Ounce / USD",
    XRPUSD: "XRP / USD",
    YEK: "Golden - GRAM"
}

export default English;